import { InterpolationWithTheme } from "@emotion/core";
import { Dictionary } from "lodash";
import { fonts } from "../fonts";


export const interventionsContainerStyles: Dictionary<InterpolationWithTheme<any>> = {
    header: {
        color: "rgb(51, 51, 51)",
        fontFamily: fonts.boldFont,
        fontSize: 18,
        padding: "15px 24px"
    }
}